import React from "react";
import "./offerReview.scss";
import MerchantDetails from "./MerchantDetails";
import OfferDetails from "./OfferDetails";

const MobileViews = ({ offerData, merchantData, selectedMerchant }) => {
  return (
    <div className="flex sm:flex-col lg:flex-row justify-center items-start sm:gap-8 md:gap-6 lg:gap-16 w-full max-w-6xl mx-auto">
      <MerchantDetails merchantData={merchantData} offerData={offerData} selectedMerchant={selectedMerchant} />
      <OfferDetails offerData={offerData} />
    </div>
  );
};

export default MobileViews;
